import { Controller } from "@hotwired/stimulus"

// Show/hide a password field. Swaps the input's TYPE and never reads its
// value, so the password does not pass through this file and cannot be
// logged by anything that instruments it.
export default class extends Controller {
  static targets = ["input", "button", "show", "hide"]

  toggle() {
    const revealed = this.inputTarget.type === "text"

    this.inputTarget.type = revealed ? "password" : "text"
    this.buttonTarget.setAttribute("aria-label", revealed ? "Show password" : "Hide password")
    this.buttonTarget.setAttribute("aria-pressed", String(!revealed))

    if (this.hasShowTarget) this.showTarget.hidden = !revealed
    if (this.hasHideTarget) this.hideTarget.hidden = revealed

    // Keep the caret where they left it.
    this.inputTarget.focus()
  }
}
